import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/shared/models/user.model';
import { timezoneData } from 'src/app/shared/utils/timezone';
import { ProfileService } from '../../profile/service/profile.service';
import { Store } from 'src/app/core/store/store';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-timezone-confirmation-modal',
  templateUrl: './timezone-confirmation-modal.component.html',
  styleUrls: ['./timezone-confirmation-modal.component.scss']
})
export class TimezoneConfirmationModalComponent implements OnInit {

  @Input() user: User;
  @Output() hideTimezoneConfirmationModal = new EventEmitter();
  config : any;
  @Input() program: any;
  timezoneDrop = timezoneData;
  timezoneObj = this.timezoneDrop.find(x => x.value == '+5:30')
  defaultTimezone = `${this.timezoneObj.label}`;
  showTimeZone = false;
  timezoneNew: any;
  
  constructor(private profileService: ProfileService,
    private toaster: ToastrService, private store: Store, private eventsService: EventsService) { }

  ngOnInit(): void {
    this.timezoneNew= '+5:30';
    this.config = {
      search:true,
      displayKey:"label",
      placeholder:'Select Timezone',
      noResultsFound: 'No results found!',
      searchPlaceholder:'Search Timezone',
      searchOnKey: 'label'
    } 
    this.store.select('user').subscribe((user: any) => {
      this.user = user;
      if(user && user['timeZone']){
        this.timezoneObj = this.timezoneDrop.find(x => x.value == user['timeZone'])
        this.timezoneSelected(this.timezoneObj)
      }
    });
  }

  showTimezone() {
    this.showTimeZone = !this.showTimeZone;
  }

  filterInitTimezone() {
    this.showTimeZone = false;
  }

  filterTimezone(event) {
    let getDiv = document.getElementById("myDropdownTimezone");

    var filter, a, i;
    filter = event.target.value.toUpperCase();
    a = getDiv.getElementsByTagName("li");
    for (i = 0; i < a.length; i++) {
      let txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";

      } else {
        a[i].style.display = "none";
      }
    }
  }

  removePhoneSearch(e) {
    var getBtnTimezone = document.querySelector(".dropbtnTimezone");
    var getInputTimezone = document.getElementById("myInputTimezone");
    if (e.target !== getBtnTimezone && e.target !== getInputTimezone) {
      this.showTimeZone = false;
    }
  }
  defaultZone= true;
  timezoneSelected(timezone) {
    this.showTimeZone = false;
    if(timezone) {
      this.defaultZone= false;
      this.defaultTimezone = `${timezone.label}`;
      this.timezoneObj = timezone;
      this.timezoneNew = timezone.value;
    }
  }

  setTimeZone(){
    this.profileService.updateTimezone({ isTimeZoneConfirmed: true, timeZone:  this.timezoneNew}).subscribe(res => {
      if (res) {
        this.toaster.success("Timezone updated successfully.");
        let eventData = { timeZone: res['data']['timeZone'], activationData: this.program[0], user: this.user };
          this.eventsService.initalTimezoneChangeEvent(eventData);
        this.hideTimezoneConfirmationModal.emit(false);
        this.store.select('user').subscribe((user: any) => {
          user.isTimeZoneConfirmed= true;
         this.store.set('user', user);
        });
      }else{
        this.toaster.error("Timezone update failed. Please try again!");
      }
    });
  }

}
